import { isElectricalExtractorWork } from "@workspace/api-zod/work-type";

export type ItemCategoryClassification = {
  category?: string;
  trade?: string;
  subcategory?: string;
};

/** Correct the extractor's automatic classification, not its price/recipe or
 * independent quote-local display placement. Used at Auto Quote boundaries. */
export function normalizeExtractorClassification<T extends ItemCategoryClassification & { name?: string }>(item: T): T {
  if (!isElectricalExtractorWork(item.category, item.name)) return item;
  if (item.category === "electrics" && item.trade === "second_fix_electrics" && item.subcategory === "second_fix_electrics") return item;
  return reassignItemCategory(item, { category: "electrics", trade: "second_fix_electrics", subcategory: "second_fix_electrics" });
}

/**
 * Changes only the classification fields used to place a quote item.
 * Keeping this as one immutable update prevents category, trade and
 * subcategory from briefly getting out of sync and protects all pricing,
 * scope and optional-work metadata on the item.
 */
export function reassignItemCategory<T extends ItemCategoryClassification>(
  item: T,
  classification: Required<ItemCategoryClassification>,
): T {
  return {
    ...item,
    category: classification.category,
    trade: classification.trade,
    subcategory: classification.subcategory,
  };
}

/**
 * A moved item must not appear to vanish just because the review screen is
 * still filtering by its former category group.
 */
export function shouldResetCategoryFilter(
  activeFilter: string | null,
  destinationGroup: string | null,
): boolean {
  return activeFilter !== null && activeFilter !== destinationGroup;
}